import { OcpsPolicy, isOcpsPolicyEnabled } from 'owa-ocps-policy-store';
import { isPrivacyRoamingEnabled } from './isPrivacyRoamingEnabled';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import {
    isOcpsPolicyEnabled as isOwsPrimeOcpsPolicyEnabled,
    PrivacyPolicySettingId,
} from 'owa-owsprime-policies-store';

export const getOptionalExperiencesPolicy = (): boolean => {
    if (!isPrivacyRoamingEnabled()) {
        return true;
    }

    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();

    return isGlobalFeatureEnabled('policy-ocps-owsprime-privacy')
        ? isOwsPrimeOcpsPolicyEnabled(
              PrivacyPolicySettingId.OptionalConnectedExperiences,
              mailboxInfo,
              true /* enabledIfUndefined */
          )
        : isOcpsPolicyEnabled(
              OcpsPolicy.OptionalConnectedExperiences,
              true /* enabledIfUndefined */,
              mailboxInfo
          );
};
